import { mapGetters, mapActions } from 'vuex'
export default {
  data () {
    let validatorCity = (rule, value, callback) => {
      if (value === 0) {
        callback(new Error('Vùng miền không được để trống'))
      } else {
        callback()
      }
    }
    return {
      loadAddress: false,
      localAddress: {
        city_id: undefined,
        district_id: undefined,
        ward_id: undefined,
        street: ''
      },
      rules: {
        city_id: [
          {required: true, validator: validatorCity, trigger: 'change'}
        ]
      },
      submitting: false
    }
  },
  computed: {
    ...mapGetters('city', ['cities']),
    ...mapGetters('district', ['districts']),
    ...mapGetters('ward', ['wards'])
  },
  methods: {
    ...mapActions('city', ['getAllCity']),
    ...mapActions('district', ['getDistrictByCityId']),
    ...mapActions('ward', ['getWardByDistrictId']),
    newCity () {
      this.localAddress = {
        city_id: undefined,
        district_id: undefined,
        ward_id: undefined,
        street: ''
      }
    },
    getDistricts () {
      if (!this.loadAddress) {
        this.localAddress.district_id = undefined
      }
      this.getDistrictByCityId({city_id: this.localAddress.city_id, limit: -1, sort: 'name:1'})
    },
    getWards () {
      if (!this.loadAddress) {
        this.localAddress.ward_id = undefined
      }
      this.getWardByDistrictId({district_id: this.localAddress.district_id, limit: -1, sort: 'name:1'})
    }
  },
  mounted () {
    this.newCity()
    if (!this.cities.length) {
      this.getAllCity({params: {limit: -1}})
    }
  },
  watch: {
    localAddress: {
      handler: function (value) {
        if (this.watching) {
          this.changedData = true
        }
      },
      deep: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/address/mixins/index.js